var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"group"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logo,"alt":"Cone logo branca"}}),_c('p',[_vm._v("© 2024 Todos os direitos reservados")])])])}
var staticRenderFns = []

export { render, staticRenderFns }